<h2 class="p-6 pb-4">{{ personalDoctor() ? "Редагування призначення лікаря" : "Додавання призначення лікаря" }}</h2>
<div class="overflow-y-auto px-6 py-0">
  @if (!loading()) {
    <div
      class="rounded-lg border-2 border-transparent p-3 shadow-inner"
      [formGroup]="personalDoctorForm"
    >
      <div [formGroupName]="'metadata'">
        <mat-form-field class="mt-2 w-full">
          <mat-label>Оберіть тип консультації</mat-label>
          <mat-select
            formControlName="serviceName"
            (selectionChange)="selectPersonalDoctorAppointmentType($event)"
          >
            @for (option of personalDoctorServiceOptions(); track option) {
              <mat-option [value]="option.nameUa"> {{ option.nameUa }} </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field class="w-full">
          <mat-label>Оберіть лікаря lilo</mat-label>
          <mat-select
            formControlName="doctorName"
            (selectionChange)="selectPersonalDoctor($event)"
          >
            @for (doctor of personalDoctorsOptions(); track doctor) {
              <mat-option [value]="doctor.fullName">
                {{ doctor.fullName }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="flex w-full gap-4">
        <mat-form-field class="w-1/2">
          <mat-label>Дата з</mat-label>
          <input
            matInput
            formControlName="startDate"
            [matDatepicker]="dateFromPicker"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="dateFromPicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #dateFromPicker> </mat-datepicker>
        </mat-form-field>
        <mat-form-field class="w-1/2">
          <mat-label>Дата до</mat-label>
          <input
            matInput
            formControlName="endDate"
            [matDatepicker]="dateTillPicker"
            [min]="personalDoctorForm.get('startDate').value"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="dateTillPicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #dateTillPicker> </mat-datepicker>
        </mat-form-field>
      </div>
      <div class="flex w-full gap-4">
        <mat-form-field class="full grow">
          <mat-label>Франшиза</mat-label>
          <input
            matInput
            formControlName="franchise"
            type="number"
            [max]="100"
            [min]="0"
          />
          @if (fc.franchise.hasError("required")) {
            <mat-error class="text-red-error">Поле обов'язкове для заповнення (ціле число від 0 до 100)</mat-error>
          }
          @if (fc.franchise.hasError("max")) {
            <mat-error class="text-red-error">Франшиза не може бути більше 100%</mat-error>
          }
          @if (fc.franchise.hasError("min")) {
            <mat-error class="text-red-error">Франшиза не може бути менше 0%</mat-error>
          }
          @if (fc.franchiseManualChangeConfirmation.hasError("required")) {
            <mat-hint class="text-red-error">Перевірте та підтвердіть зміну відсотку франшизи</mat-hint>
          }
        </mat-form-field>
        @if (franchiseInitialValue() !== fc.franchise.value) {
          <mat-checkbox
            formControlName="franchiseManualChangeConfirmation"
            matTooltip="Підтверджую зміну відсотку франшизи"
            matTooltipPosition="above"
            color="primary"
          >
          </mat-checkbox>
        }
      </div>
      <mat-form-field class="w-full">
        <mat-label>Статус</mat-label>
        <mat-select formControlName="guaranteeStatus">
          @for (status of guaranteeStatusOptions; track status) {
            <mat-option
              [value]="status"
              [ngClass]="{ '!hidden': status === guaranteeStatus.Auto || status === guaranteeStatus.WaitProcessing }"
            >
              {{ "statuses.guarantationStatuses." + status | translate }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (fc.guaranteeStatus.value === guaranteeStatus.Guaranteed) {
        <mat-form-field class="w-full">
          <mat-label>{{ "prescription.label.editReason" | translate }}</mat-label>
          <input
            matInput
            formControlName="statusReason"
          />
        </mat-form-field>
      } @else {
        <mat-form-field class="w-full">
          <mat-label>{{ "prescription.label.declineReason" | translate }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="statusReason"
            [matAutocomplete]="declineReasonAutocomplete"
          />
          <mat-autocomplete #declineReasonAutocomplete="matAutocomplete">
            @for (reason of filteredDeclineReasons(); track reason) {
              <mat-option [value]="reason">
                {{ reason }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      }
    </div>
  } @else {
    <div class="flex items-center justify-center">
      <shared-loader></shared-loader>
    </div>
  }
</div>

<div class="flex justify-end gap-4 p-6">
  <button
    class="btn btn-secondary"
    [type]="'button'"
    [disabled]="loading()"
    (click)="closeDialog()"
  >
    Скасувати
  </button>
  <button
    class="btn btn-primary"
    [type]="'submit'"
    [disabled]="loading() || fc.completedInAppointment.value === true"
    (click)="submitDraft()"
  >
    Зберегти чернетку
  </button>
  @if (!!guaranteeApplicationId() && (!personalDoctor() || !!personalDoctor()?.creationDate)) {
    <button
      class="btn btn-primary"
      [type]="'submit'"
      [disabled]="loading()"
      (click)="submitPrescription()"
    >
      Зберегти
    </button>
  }
</div>
